/**
 * The `UnifiedBaseTypography` object defines a typography configuration for Material-UI,
 * allowing for customizable typographic styles across the application. This includes
 * setting font sizes, weights, and margins for various heading levels.
 *
 * Key Properties:
 * - `htmlFontSize`: Base font size for the application (16px).
 * - `fontFamily`: The font family to be used (Rubik).
 * - `h1`, `h2`, `h3`, `h4`, `h5`, `h6`: Custom styles for each heading level, including font size,
 *   weight, and margin.
 *
 * @returns {BackstageTypography} The typography configuration object.
 * @category Theming
 */
export const UnifiedBaseTypography = {
  htmlFontSize: 14,
  fontFamily: 'Rubik',
  h1: {
    fontSize: 57,
    fontWeight: 400,
    marginBottom: 2,
  },
  h2: {
    fontSize: 45,
    fontWeight: 400,
    marginBottom: 2,
  },
  h3: {
    fontSize: 36,
    fontWeight: 400,
    marginBottom: 2,
  },
  h4: {
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 2,
  },
  h5: {
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 2,
  },
  h6: {
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 2,
  },
};
